import { deviceEnquire, DEVICE_TYPE } from './device'
import { mapGetters } from 'vuex'

const mixinDevice = {
  computed: {
    ...mapGetters([
      'device'
    ])
  },
  methods: {
    isPhone() {
      return this.device === DEVICE_TYPE.PHONE
    },
    isDesktop () {
      return this.device === DEVICE_TYPE.DESKTOP
    },
    isPad () {
      return this.device === DEVICE_TYPE.PAD
    }
  }
};


const AppDeviceEnquire = {
  mounted () {
    const { $store } = this;
    deviceEnquire(deviceType => {
      switch (deviceType) {
        case DEVICE_TYPE.DESKTOP:
          $store.commit('TOGGLE_DEVICE', 'desktop');
          break;
        case DEVICE_TYPE.PAD:
          $store.commit('TOGGLE_DEVICE', 'pad');
          break;
        case DEVICE_TYPE.PHONE:
        default:
          $store.commit('TOGGLE_DEVICE', 'phone');
          break
      }
    })
  }
};


export { mixinDevice,AppDeviceEnquire }



// WEBPACK FOOTER //
// ./src/utils/mixin.js